import React, { useEffect, useState } from "react";
import * as sweetalert from "sweetalert";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Grid } from "@material-ui/core";
import Controls from "../global/controls/Controls";
import { useForm, Form } from "./useForm";
import packageJson from "../../../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export default function ViewproviderMTN() {
  const navigate = useNavigate();
  const location = useLocation();
  const [Countries, setCountries] = useState("");
  const [ErrorLocation, setErrorLocation] = useState(false);
  const [loading, setLoading] = useState(false);

  const { id } = useParams();
  const initialFValues = {
    DealerCode: "",
    DealerPass: "",
    DealerPassCache: "",
    DealerUserName: "",
    OwnerDistributor: "",
    DealerGSM: "",
    GPS: "",
  };
  useEffect(() => {
    axios
      .get(`${BaseUrl}/api/country/1/cities`, {
        withCredentials: true,
      })
      .then((res) => {
        setCountries(res.data.data);
      });
},[]);
  const validate = (fieldValues = loginInput) => {
    let temp = { ...errors };

    if ("DealerCode" in fieldValues)
      temp.DealerCode = fieldValues.DealerCode ? "" : "هذا الحقل  مطلوب";
    if ("DealerPass" in fieldValues)
      temp.DealerPass = fieldValues.DealerPass ? "" : "هذا الحقل مطلوب";
    if ("DealerPassCache" in fieldValues)
      temp.DealerPassCache = fieldValues.DealerPassCache ? "" : "هذا الحقل مطلوب";
    if ("DealerUserName" in fieldValues)
      temp.DealerUserName = fieldValues.DealerUserName ? "" : "هذا الحقل مطلوب";
    if ("OwnerDistributor" in fieldValues)
      temp.OwnerDistributor = fieldValues.OwnerDistributor ? "" : "هذا الحقل مطلوب";
    if ("DealerGSM" in fieldValues)
      temp.DealerGSM = fieldValues.DealerGSM ? "" : "هذا الحقل مطلوب";
    if ("GPS" in fieldValues)
      temp.GPS = fieldValues.GPS ? "" : "هذا الحقل مطلوب";

    setErrors({
      ...temp,
    });
    if (fieldValues == loginInput)
      return Object.values(temp).every((x) => x == "");
  };
  const {
    loginInput,
    setLogin,
    errors,
    setErrors,
    handleInputChange,
    addForm,
  } = useForm(initialFValues, true, validate);
  useEffect(() => {
    axios
      .get(
        `${BaseUrl}/api/distributor/${id}`,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        setLogin({
          DealerCode: res.data.data.DealerCode,
          DealerPass: res.data.data.DealerPass,
          DealerPassCache: res.data.data.DealerPassCache,
          DealerUserName: res.data.data.DealerUserName,
          OwnerDistributor: res.data.data.OwnerDistributor,
          DealerGSM: res.data.data.DealerGSM,
          GPS: res.data.data.GPS,
        });
      })
      .catch((err) => {});
  }, []);
  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (validate()) {
      setLoading(true);
      const bodyFormData = new FormData();
      bodyFormData.append("DealerCode", loginInput.DealerCode);
      bodyFormData.append("DealerPass", loginInput.DealerPass);
      bodyFormData.append("DealerPassCache", loginInput.DealerPassCache);
      bodyFormData.append("DealerUserName", loginInput.DealerUserName);
      bodyFormData.append("OwnerDistributor", loginInput.OwnerDistributor);
      bodyFormData.append("DealerGSM", loginInput.DealerGSM);
      bodyFormData.append("GPS", loginInput.GPS);

      axios
        .post(
          `${BaseUrl}/api/updateDistributor/${id}`,
          bodyFormData,
          {
            withCredentials: true,
          }
        )
        .then((res) => {
          if (res.data.status === true) {
            setLoading(false);
            sweetalert(res.data.msg, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            }).then(() => {
              navigate("/providers-mtn");
            });
          } else {
            setLoading(false);
            sweetalert(res.data.msg, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            });
          }
        });
    }
    
  };

  useEffect(() => {
    if(loading === true && !validate()) {
    setTimeout(() => {
      // After the timeout, reset the loading state
      setLoading(false);
      // Your other logic here
    }, 2000); // Adjust the timeout duration as needed
    }
  }, [loading]);
  return (
    <div className="main-div" >
      {location.state.mod === "View" ? (
        <h3 className="titlepage">استعراض نقطة البيع MTN</h3>
      ) : (
        <h3 className="titlepage">تعديل نقطة البيع MTN</h3>
      )}

      <Form
        className="form-group new-design"
        method="post"
        enctype="multipart/form-data"
        onSubmit={handleSubmit}
      >
        <Grid container maxWidth="sm" spacing={4}>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="كود نقطة البيع"
              name="DealerCode"
              variant="outlined"
              fullWidth
              required
              disabled={location.state.mod === "View" ? true : false}
              onChange={handleInputChange}
              value={loginInput.DealerCode}
              className="form-control"
              error={errors.DealerCode}
              type="text"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="كلمة مرور نقطة البيع"
              name="DealerPass"
              variant="outlined"
              fullWidth
              required
              onChange={handleInputChange}
              value={loginInput.DealerPass}
              className="form-control"
              error={errors.DealerPass}
              disabled={location.state.mod === "View" ? true : false}
              type="text"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label=" كلمة مرور نقطة البيع كاش"
              name="DealerPassCache"
              variant="outlined"
              fullWidth
              required
              onChange={handleInputChange}
              value={loginInput.DealerPassCache}
              className="form-control"
              error={errors.DealerPassCache}
              disabled={location.state.mod === "View" ? true : false}
              type="text"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="اسم مستخدم نقطة البيع"
              name="DealerUserName"
              variant="outlined"
              fullWidth
              required
              disabled={location.state.mod === "View" ? true : false}
              onChange={handleInputChange}
              value={loginInput.DealerUserName}
              className="form-control"
              error={errors.DealerUserName}
              type="text"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="مالك نقطة البيع"
              name="OwnerDistributor"
              variant="outlined"
              fullWidth
              required
              disabled={location.state.mod === "View" ? true : false}
              onChange={handleInputChange}
              value={loginInput.OwnerDistributor}
              className="form-control"
              error={errors.OwnerDistributor}
              type="text"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="سيم  نقطة البيع"
              name="DealerGSM"
              variant="outlined"
              fullWidth
              required
              disabled={location.state.mod === "View" ? true : false}
              onChange={handleInputChange}
              value={loginInput.DealerGSM}
              className="form-control"
              error={errors.DealerGSM}
              type="text"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <div class="select">
              <select
                required
                onChange={handleInputChange}
                name="GPS"
                class="select-text"
                value={loginInput.GPS}
                disabled={location.state.mod === "View" ? true : false}
              >
                <option selected disabled className="title-option">
                  المنطقة
                </option>
                {Countries && Countries.map((opts) => (
                  <option  value={opts.name_ar}>
                    {opts.name_ar}
                  </option>
                ))}
              </select>
              <span class="select-highlight"></span>
              <span class="select-bar"></span>
              <label class="select-label">المحافظة</label>
            </div>
            {loginInput.GPS ==''?(
            <div style={{ color: "red", fontSize: "10px" ,textAlign:'end'}}>
              {errors.GPS}
            </div>
            ):(
              <></>
            )}

          </Grid>
        </Grid>
        {location.state.mod === "View" ? (
          <></>
        ) : (
          <Grid item md={6} xs={12} spacing={2} class="div-btn-submit">
          {loading === true ? (
            <Controls.Button
              type="submit"
              text=<div class="spinner center">
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
              </div>
              variant="contained"
              className="btn-submit"
            ></Controls.Button>
          ) : (
            <Controls.Button
              type="submit"
              text="تعديل"
              onClick={addForm}
              variant="contained"
              className="btn-submit"
            ></Controls.Button>
          )}
          </Grid>
        )}
      </Form>
    </div>
  );
}
